// src/context/SavedEventsContext.js
import React, { createContext, useContext, useState } from "react";
import REACT_APP_API_URL from "../utils/constant";

const SavedEventsContext = createContext();

export const SavedEventsProvider = ({ children }) => {
  const [savedEvents, setSavedEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSavedEvents = async (userId) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${REACT_APP_API_URL}get-wishlist/${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        }
      );
      const result = await response.json();
      console.log("Saved Events:", result);
      if (result.data) {
        setSavedEvents(result.data);
      }
      return result.data;
    } catch (e) {
      console.error("Error fetching saved events:", e);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return (
    <SavedEventsContext.Provider
      value={{
        savedEvents,
        loading,
        fetchSavedEvents,
      }}
    >
      {children}
    </SavedEventsContext.Provider>
  );
};

export const useSavedEvents = () => useContext(SavedEventsContext);
